type Item = {
  name: string;
  to: string;
};

export const categoryLinkList = [
  {
    name: 'トップ',
    to: '/',
  },
  {
    name: 'テクノロジー',
    to: '/technology/',
  },
  {
    name: 'モバイル',
    to: '/mobile/',
  },
  {
    name: 'アプリ',
    to: '/app/',
  },
  {
    name: 'エンタメ',
    to: '/entertainment/',
  },
  {
    name: 'ビューティー',
    to: '/beauty/',
  },
  {
    name: 'ファッション',
    to: '/fashion/',
  },
  {
    name: 'ライフスタイル',
    to: '/lifestyle/',
  },
  {
    name: 'ビジネス',
    to: '/business/',
  },
  {
    name: 'グルメ',
    to: '/gourmet/',
  },
  {
    name: 'スポーツ',
    to: '/sports/',
  },
] satisfies Item[];

export const facebookLinkList = [
  {
    name: '公式Facebookページ',
    to: 'https://www.facebook.com/prtimes.jp',
  },
  {
    name: 'PR TIMES STORY',
    to: 'https://www.facebook.com/STORYBYPRTIMES/',
  },
  {
    name: 'PR TIMES TV',
    to: 'https://www.facebook.com/prtimes.tv',
  },
  {
    name: 'ニュース',
    to: 'https://twitter.com/PRTIMES_NEWS',
  },
  {
    name: 'テクノロジー',
    to: 'https://www.facebook.com/prtimes.tech',
  },
  {
    name: 'アプリケーション',
    to: 'https://www.facebook.com/PR-TIMES-%E3%82%A2%E3%83%97%E3%83%AA-432374826901950',
  },
  {
    name: 'スタートアップ',
    to: 'https://www.facebook.com/prtimes.startup',
  },
  {
    name: 'エンタメ',
    to: 'https://www.facebook.com/prtimes.entertainment',
  },
  {
    name: 'ビューティ',
    to: 'https://www.facebook.com/prtimes.beauty',
  },
  {
    name: 'ファッション',
    to: 'https://www.facebook.com/prtimes.fashion',
  },
  {
    name: 'ライフスタイル',
    to: 'https://www.facebook.com/prtimes.lifestyle',
  },
  {
    name: 'トラベル',
    to: 'https://www.facebook.com/prtimes.travel',
  },
  {
    name: 'グルメ',
    to: 'https://www.facebook.com/prtimes.gourmet',
  },
  {
    name: 'ゲーム',
    to: 'https://www.facebook.com/PR-TIMES-%E3%82%B2%E3%83%BC%E3%83%A0-724044057618274',
  },
  {
    name: 'スポーツ',
    to: 'https://www.facebook.com/PR-TIMES-%E3%82%B9%E3%83%9D%E3%83%BC%E3%83%84-513253112109063',
  },
  {
    name: 'ビデオ',
    to: 'https://www.facebook.com/prtimes.video',
  },
  {
    name: 'ビジネス',
    to: 'https://www.facebook.com/prtimes.business',
  },
  {
    name: 'マーケティング',
    to: 'https://www.facebook.com/prtimes.marketing',
  },
] satisfies Item[];

export const recommendLinkList = [
  {
    name: 'PR TIMES STORY',
    to: '/story',
  },
  {
    name: '無料FAQならTayori',
    to: 'https://tayori.com/feature/faq',
  },
  {
    name: '無料メールフォームならTayori',
    to: 'https://tayori.com/feature/form',
  },
  {
    name: 'タスク・プロジェクト管理ツールのJooto',
    to: 'https://www.jooto.com/',
  },
  {
    name: '動画制作・動画PRならPR TIMES TV',
    to: 'https://prtimes.jp/tv/info_tv?utm_source=prtimes&utm_medium=footer',
  },
  {
    name: '記者発表・イベント配信ならPR TIMES LIVE',
    to: 'https://prtimes.jp/tv/info_live?utm_source=prtimes&utm_medium=footer',
  },
  {
    name: 'PR TIMES MAGAZINE',
    to: 'https://prtimes.com/magazine/',
  },
  {
    name: 'クリッピング',
    to: 'https://prtimes.jp/webclipping/service/',
  },
  {
    name: '広告ならPR EDGE',
    to: 'https://predge.jp/',
  },
] satisfies Item[];

export const twitterLinkList = [
  {
    name: '公式Xページ',
    to: 'https://twitter.com/PRTIMES_JP',
  },
  {
    name: 'PR TIMES STORY',
    to: 'https://twitter.com/PRTIMES_STORY',
  },
  {
    name: 'PR TIMES TV',
    to: 'https://twitter.com/PRTIMES_TV',
  },
  {
    name: 'ニュース',
    to: 'https://twitter.com/PRTIMES_NEWS',
  },
  {
    name: 'テクノロジー',
    to: 'https://twitter.com/PRTIMES_TECH',
  },
  {
    name: 'アプリケーション',
    to: 'https://twitter.com/PRTIMES_APP',
  },
  {
    name: 'スタートアップ',
    to: 'https://twitter.com/PRTIMES_STUP',
  },
  {
    name: 'エンタメ',
    to: 'https://twitter.com/PRTIMES_ETM',
  },
  {
    name: 'ビューティ',
    to: 'https://twitter.com/PRTIMES_BEAUTY',
  },
  {
    name: 'ファッション',
    to: 'https://twitter.com/PRTIMES_FASHION',
  },
  {
    name: 'ライフスタイル',
    to: 'https://twitter.com/PRTIMES_LIFE',
  },
  {
    name: 'トラベル',
    to: 'https://twitter.com/PRTIMES_TRAVEL',
  },
  {
    name: 'グルメ',
    to: 'https://twitter.com/PRTIMES_GOURMET',
  },
  {
    name: 'ゲーム',
    to: 'https://twitter.com/PRTIMES_GAMES',
  },
  {
    name: 'スポーツ',
    to: 'https://twitter.com/PRTIMES_SPORTS',
  },
  {
    name: 'ビデオ',
    to: 'https://twitter.com/PRTIMES_VIDEO',
  },
  {
    name: 'ビジネス',
    to: 'https://twitter.com/PRTIMES_BIZ',
  },
  {
    name: 'マーケティング',
    to: 'https://twitter.com/PRTIMES_MKTG',
  },
] satisfies Item[];
